import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import classes from './InfoPage.module.scss';
import { INFO_PAGES } from './infoPagesContent';

/**
 * Renders any of the static footer pages from INFO_PAGES, keyed by the `:slug`
 * route param. An unknown slug falls back to the home page.
 */
export const InfoPage = () => {
    const { slug } = useParams();
    const page = INFO_PAGES[slug];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [slug]);

    if (!page) return <Navigate to="/" replace />;

    return (
        <div className={classes.Page}>
            <h1 className={classes.PageTitle}>{page.title}</h1>

            {page.sections.map((section, sectionIndex) => (
                <div
                    key={section.heading || sectionIndex}
                    className={`${classes.Section} ${section.dir === 'rtl' ? classes.Rtl : ''}`}
                    dir={section.dir}
                    lang={section.lang}
                >
                    {section.heading ? <h2 className={classes.SectionHeading}>{section.heading}</h2> : null}
                    {section.paragraphs.map((paragraph, paragraphIndex) => (
                        <p key={paragraphIndex} className={classes.Paragraph}>
                            {paragraph}
                        </p>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default InfoPage;
